/* eslint-disable max-len */
import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  makeStyles,
  // useTheme,
} from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import CreateIcon from '@material-ui/icons/Create';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
// import useMediaQuery from '@material-ui/core/useMediaQuery';
import CircularProgress from '@material-ui/core/CircularProgress';
import { camelize } from 'humps';
import withForm from '../../hocs/withForm';
import CustomPropTypes from '../../helpers/CustomPropTypes';
import DownloadIcon from '../../assets/DownloadIcon';
import CountryField from '../CountryField';
import CustomField from '../CustomField';
import FileModal from '../FileModal';
// import MyQrButton from '../MyQrButton';
import { getCurrentAttendee } from '../../helpers/getters';
import parseCustomFields, { parseFieldsByInternalId } from '../../helpers/customFields';
import emailRegexp from '../../helpers/strings';
// import moduleEnabledForCurrentAttendeeType
//  from '../../helpers/moduleEnabledForCurrentAttendeeType';
import INPUT_TYPES, {
  // ATTENDANCE_MODE
  INTERNAL_IDS,
} from '../../helpers/constants';
import InputBase from '../InputBase';
import PhoneInput from '../PhoneInput';
import DateInput from '../DateInput';
import FlightInput from '../FlightInput';
import Button from '../Button';
import { baseMoment } from '../../helpers/dates';
import { visaInvitationLinkEnabled, downloadVisaInvitationLink } from '../../helpers/visaInvitation';
import SelectYourActivity from './SelectYourActivity';

// const { VIRTUAL } = ATTENDANCE_MODE;
const fieldSizes = {
  // [INTERNAL_IDS.arrivalTime]: 6,
  [INTERNAL_IDS.downloadInvitationLetter]: 6,
  // [INTERNAL_IDS.departureFrom]: 6,
  // [INTERNAL_IDS.departureTime]: 6,
  // [INTERNAL_IDS.departureTo]: 6,
  // [INTERNAL_IDS.departureDate]: 4,
  // [INTERNAL_IDS.arrivalDate]: 4,
  // [INTERNAL_IDS.departurePickUpTime]: 8,
  [INTERNAL_IDS.passportNumber]: 6,
  [INTERNAL_IDS.passportExpiryDate]: 6,
  [INTERNAL_IDS.checkIn]: 6,
  [INTERNAL_IDS.checkOut]: 6,
  // needtransfer: 8,
  birthdate: 6,
  // Departure: 8,
  [INTERNAL_IDS.emergencyContactName]: 6,
  [INTERNAL_IDS.emergencyContactPhone]: 6,
  [INTERNAL_IDS.accompanyingGuestFirstName]: 6,
  [INTERNAL_IDS.accompanyingGuestLastName]: 6,
  [INTERNAL_IDS.arrivalDate]: 6,
  [INTERNAL_IDS.needArrivalAirportTransfer]: 6,
  [INTERNAL_IDS.arrivalFlightNumber]: 12,
  [INTERNAL_IDS.arrivalTime]: 12,
  [INTERNAL_IDS.arrivalFrom]: 6,
  [INTERNAL_IDS.arrivalTo]: 6,
  [INTERNAL_IDS.departureDate]: 6,
  [INTERNAL_IDS.needDepartureAirportTransfer]: 6,
  [INTERNAL_IDS.departureFlightNumber]: 12,
  [INTERNAL_IDS.departureTime]: 12,
  [INTERNAL_IDS.departureFrom]: 6,
  [INTERNAL_IDS.departureTo]: 6,
  // MY PROGRAM
  [INTERNAL_IDS.sundayDinner]: 12, // sunday's dinner is optional
  selectYourActivity: 12,
  [INTERNAL_IDS.needHelpPhone]: 6,
};

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    marginTop: theme.spacing(1),
    textAlign: 'right',
  },
  customFieldsWrapper: {
    marginTop: 6,
  },
  simpleInput: {
    background: 'none',
    fontWeight: 'normal',
  },
  mainInfoWrapper: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column-reverse',
    },
  },
  profileHeader: {
    alignItems: 'center',
    margin: theme.spacing(0, 0, 2.5, 0),
    display: 'flex',
    width: '100%',
  },
  profilePhotoTitle: {
    alignSelf: 'start',
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
    },
  },
  avatarGrid: {
    paddingRight: 36,
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
      marginTop: theme.spacing(4),
    },
  },
  avatarWrapper: {
    position: 'relative',
    padding: theme.spacing(0, 2),
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      paddingBottom: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center',
    },
  },
  labelText: {
    fontSize: 14,
    paddingLeft: 15,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  editPhotoButton: {
    position: 'absolute',
    width: 32,
    height: 32,
    zIndex: 100,
    right: 8,
    bottom: 40,
    backgroundColor: theme.palette.background.default,
    '&:hover': {
      backgroundColor: theme.palette.lightGrey.main,
    },
    '& svg': {
      height: 20,
      width: 20,
    },
    [theme.breakpoints.down('sm')]: {
      right: -theme.spacing(0.5),
      bottom: 0,
    },
  },
  avatar: {
    top: 18,
    height: 170,
    width: 170,
    marginLeft: theme.spacing(2),
    backgroundColor: theme.palette.lightGrey.main,
    color: theme.palette.primary.main,
  },
  name: {
    fontSize: 16,
    color: theme.palette.darkGrey.dark,
    fontWeight: 'bold',
  },
  job: {
    color: theme.palette.darkGrey.main,
    fontSize: 14,
  },
  divider: {
    margin: theme.spacing(2, -3),
  },
  progressWrapper: {
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    width: 83,
    height: 83,
    right: 0,
    top: 0,
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      right: -theme.spacing(3),
    },
  },
  progress: {
    position: 'absolute',
    left: 0,
    top: 0,
  },
  progressBakcground: {
    color: theme.palette.lightGrey.main,
    position: 'absolute',
    left: 0,
    top: 0,
  },
  progressValue: {
    fontSize: 24,
    color: theme.palette.primary.main,
  },
  progressComplete: {
    position: 'absolute',
    top: -theme.spacing(4),
    left: theme.spacing(4),
    color: theme.palette.primary.main,
    width: '100%',
    fontSize: 14,
    display: 'flex',
    // justifyContent: 'center',
    fontWeight: 700,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      whiteSpace: 'normal',
      top: -theme.spacing(5),
    },
    [theme.breakpoints.down('sm')]: {
      left: 0,
      whiteSpace: 'nowrap',
    },
  },
  headshotReminder: {
    position: 'absolute',
    bottom: 0,
    right: 28,
    left: 0,
    color: theme.palette.primary.main,
    fontSize: 15,
    textAlign: 'center',
    fontWeight: 700,
    zIndex: 1,
    backgroundColor: 'rgba(255,255,255,0.8)',
    [theme.breakpoints.down('sm')]: {
      left: -24,
    },
  },
  downloadVisaInvitationButton: {
    fontWeight: 600,
    width: '100%',
    padding: '0px 16px',
    minHeight: 34,
    color: '#ffffff',
    backgroundColor: theme.palette.primary.main,
    fontSize: 15,
    fontStyle: 'normal',
    fontFamily: 'Brilliant Cut Pro',
    borderRadius: 0,
    border: 0,
    cursor: 'pointer',
    textDecoration: 'none',
    // textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(1.5),
    lineHeight: '100%',
    '& img': {
      width: 20,
      height: 20,
      marginRight: theme.spacing(),
      marginTop: theme.spacing(-1),
    },
  },
  downloadVisaInvitationButtonDisabled: {
    backgroundColor: theme.palette.lightGrey.dark,
    pointerEvents: 'none',
  },
  hiddenField: {
    display: 'none',
  },
  guestEmailMessage: {
    color: theme.palette.error.main,
    fontSize: 12,
    marginTop: theme.spacing(0.5),
    display: 'block',
  },
}));

const cantArrivalTransferFieldName = '<div style="font-size: 20px;">Transfers between the airport and the hotel will be arranged only during the event according to your travel details.</div>';
const cantDepartureTransferFieldName = '<div style="font-size: 20px;">Transfers between the hotel and the airport will be arranged only during the event according to your travel details.</div>';
const specifyYourSpecialDietName = '<div style="font-size: 20px; text-align: center;">Specify your special diet</div>';
// NOTA: CADA NOMBRE DEBE SER UNICO PARA EVITAR COMPORTAMIENTOS INESPERADOS RANDOM
// const disabledModificationsDietaName = '<div style=" font-weight: 700; font-size: 16px;
// color: orange; font-family: Avenir Next; font-style: italic; margin-top: -24px;">
// From now on, for any modification, please contact directly
// <u>maisoncommittee@vancleefarpels.com</u></div>';
const checkinCheckoutPreFilledName = '<div style="color: orange; font-size: 16px; font-weight: 700; font-family: Brilliant Cut Pro; font-style: italic; margin-top: -24px;">From now on, for any modification, please contact directly <u>maisoncommittee@vancleefarpels.com</u></div>';
const disabledModificationsArrivalName = '<div style="font-family: Brilliant Cut Pro; font-size: 16px; font-weight: 700; color: orange; font-style: italic; margin-top: -24px;">From now on, for any modification, please contact directly <u>maisoncommittee@vancleefarpels.com</u></div>';
const disabledModificationsAgendaName = '<div style="font-size: 16px; font-family: Brilliant Cut Pro; font-weight: 700; color: orange; font-style: italic; margin-top: -24px;">From now on, for any modification, please contact directly <u>maisoncommittee@vancleefarpels.com</u></div>';
// FIN NOTA
const selectYourActivityName = <SelectYourActivity />;

const validateField = (obj, id, name) => {
  if (obj[id] !== undefined) return obj[id];
  return obj[name];
};

const getCustomFieldValue = (allValues, id, name) => (
  allValues?.[`attendee[customFields]._${id}`]
  || allValues?.attendee?.customFields?.[`_${id}`]
  || allValues?.[`attendee[${name}]`]
  || allValues?.attendee?.[name]
);

const progressFields = {
  // PROFILE
  [INTERNAL_IDS.lastName]: true, // Last Name
  [INTERNAL_IDS.firstName]: true, // First Name
  [INTERNAL_IDS.function]: true, // Function
  // [INTERNAL_IDS.telephone]: true, // Telephone
  [INTERNAL_IDS.email]: true, // Email
  [INTERNAL_IDS.photo]: true, // Photo
  [INTERNAL_IDS.emergencyContactName]: true, // emergency contact name
  [INTERNAL_IDS.emergencyContactPhone]: true, // emergency phone number
  // HOTEL
  [INTERNAL_IDS.hotelName]: true, // Hotel name
  [INTERNAL_IDS.checkIn]: true, // Check in
  [INTERNAL_IDS.checkOut]: true, // Check out
  // TRANSFER
  [INTERNAL_IDS.arrivalDate]: true, // Arrival date
  [INTERNAL_IDS.needArrivalAirportTransfer]: { // Arrival airport transfer
    YES: {
      [INTERNAL_IDS.arrivalFlightNumber]: true, // Arrival flight number
      [INTERNAL_IDS.arrivalTime]: true, // Arrival time
      [INTERNAL_IDS.arrivalFrom]: true, // Arrival from
      [INTERNAL_IDS.arrivalTo]: true, // Arrival to
    },
  },
  [INTERNAL_IDS.departureDate]: true, // Departure date
  [INTERNAL_IDS.needDepartureAirportTransfer]: { // Need Departure Airport Transfer
    YES: {
      [INTERNAL_IDS.departureFlightNumber]: true, // Departure flight number
      [INTERNAL_IDS.departureTime]: true, // Departure time
      [INTERNAL_IDS.departureTo]: true, // Departure to
      [INTERNAL_IDS.departureFrom]: true, // Departure from
    },
  },
  // MEALS
  [INTERNAL_IDS.dietaryRequirements]: { // Dietary Requirements
    Yes: {
      [INTERNAL_IDS.specifyYourSpecialDiet]: true, // Specify your special diet
    },
  },
  // MY PROGRAM
  // [INTERNAL_IDS.sundayDinner]: true, // sunday dinner,
  // [INTERNAL_IDS.optionalActivity]: true, // TODO optional activity
};

export const getProgress = (formValues, currentAttendee, attendeeTypeCustomFields) => {
  const fieldsId = parseFieldsByInternalId(currentAttendee.fields, attendeeTypeCustomFields);

  let numRequiredFields = 0;
  let numFilledFields = 0;

  Object.keys(progressFields).forEach((fieldInternalId) => {
    if (!attendeeTypeCustomFields[fieldsId[fieldInternalId]]?.display) return;

    numRequiredFields += 1;

    const { id, name } = attendeeTypeCustomFields[fieldsId[fieldInternalId]];
    const value = getCustomFieldValue(formValues, id, name);
    if (value) numFilledFields += 1;

    const additionalRequirements = progressFields[fieldInternalId][value];

    if (additionalRequirements) Object.keys(additionalRequirements).forEach((addReqInternalId) => {
      if (!attendeeTypeCustomFields[fieldsId[addReqInternalId]]?.display) return;

      numRequiredFields += 1;

      const {
        id: nestedId,
        name: nestedName,
      } = attendeeTypeCustomFields[fieldsId[addReqInternalId]];
      const nestedValue = getCustomFieldValue(formValues, nestedId, nestedName);
      if (nestedValue) numFilledFields += 1;

      const secondAdditionalRequirements = (
        additionalRequirements[addReqInternalId][nestedValue]
      );

      if (secondAdditionalRequirements) Object.keys(secondAdditionalRequirements).forEach(
        (secAddReqInternalId) => {
          if (!attendeeTypeCustomFields[fieldsId[secAddReqInternalId]]?.display) return;

          numRequiredFields += 1;

          const secondAddReqId = fieldsId[secAddReqInternalId];
          const secondAddReqValue = getCustomFieldValue(formValues, secondAddReqId);
          if (secondAddReqValue) numFilledFields += 1;
        }
      );
    });
  });

  if (numRequiredFields === 0) return 0;
  return Math.round((numFilledFields * 100.0) / numRequiredFields);
};

// export const getProgress = (formValues, currentAttendee, attendeeTypeCustomFields) => {
//   const { attendeeType: { id: currentAttendeeTypeId } } = currentAttendee;
//   const requiredFields = Object.values(attendeeTypeCustomFields).filter(
//     ({ required, attendeeType: { id: attendeeTypeId } }) => (
//       (currentAttendeeTypeId === attendeeTypeId) && !!required
//     )
//   );
//   const numRequiredFields = requiredFields.length;
//   const numFilledFields = requiredFields.filter(
//     ({ id, name }) => (
//       !!formValues[`attendee[${name}]`]
//       || !!formValues[`attendee[customFields]._${id}`]
//       || !!formValues?.attendee?.[name]
//       || !!formValues?.attendee?.customFields?.[`_${id}`]
//     )
//   ).length;
//   return Math.round((numFilledFields * 100.0) / numRequiredFields);
// };

const frontPreValidations = (formValues, fieldsId) => {
  const arrivalDateId = fieldsId[INTERNAL_IDS.arrivalDate];
  const hotelCheckInId = fieldsId[INTERNAL_IDS.checkIn];
  const hotelCheckOutId = fieldsId[INTERNAL_IDS.checkOut];
  const departureDateId = fieldsId[INTERNAL_IDS.departureDate];

  const arrivalDate = formValues[`attendee[customFields]._${arrivalDateId}`];
  const hotelCheckInDate = formValues[`attendee[customFields]._${hotelCheckInId}`];
  const hotelCheckOutDate = formValues[`attendee[customFields]._${hotelCheckOutId}`];
  const departureDate = formValues[`attendee[customFields]._${departureDateId}`];

  const errors = {};

  if (
    !!arrivalDate
    && !!hotelCheckInDate
    && baseMoment(hotelCheckInDate).isBefore(arrivalDate)
  ) errors[hotelCheckInId] = 'Check in date can\'t be earlier than arrival date';
  if (
    !!departureDate
    && !!hotelCheckOutDate
    && baseMoment(hotelCheckOutDate).isAfter(departureDate)
  ) errors[hotelCheckOutId] = 'Check out date can\'t be after departure date';
  if (
    !!hotelCheckInDate
    && !!hotelCheckOutDate
    && baseMoment(hotelCheckInDate).isAfter(hotelCheckOutDate)
  ) errors[hotelCheckOutId] = 'Check out date can\'t be earlier than check in date';
  if (
    !!arrivalDate
    && !!departureDate
    && baseMoment(arrivalDate).isAfter(departureDate)
  ) errors[arrivalDateId] = 'Arrival date can\'t be after departure date';

  return errors;
};

const airportValidations = (formValues, fieldsId) => {
  const arrivalToId = fieldsId[INTERNAL_IDS.arrivalTo];
  const departureFromId = fieldsId[INTERNAL_IDS.departureFrom];

  const arrivalTo = formValues[`attendee[customFields]._${arrivalToId}`];
  const departureFrom = formValues[`attendee[customFields]._${departureFromId}`];

  const validAirports = ['DMK', 'BKK'];
  const isValidAirport = (fieldValue) => {
    if (!fieldValue) return false;
    const airportCode = fieldValue.split('-')[1];
    return validAirports.some((code) => airportCode.includes(code));
  };

  const messages = {};

  if (arrivalTo && !isValidAirport(arrivalTo)
  ) messages[arrivalToId] = 'Your arrival airport is not valid, please indicate your flight number landing in Suvarnabhumi Airport or Don Mueang International Airport';
  if (departureFrom && !isValidAirport(departureFrom)
  ) messages[departureFromId] = 'Your departure airport is not valid, please indicate your flight number taking off from Suvarnabhumi Airport or Don Mueang International Airport';

  return messages;
};

const MyProfileForm = ({
  registerInput, errors, entities, attendeeTypeCustomFields: attendeeTypeCustomFieldsRaw,
  setFormValue, watchFormValues, setError, customErrors, clearError, disabled: submitDisabled,
  // attendeeTypes,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('global');
  // const theme = useTheme();
  // const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [openEditPhoto, setOpenEditPhoto] = useState(false);
  const [openArrivalWarning, setOpenArrivalWarning] = useState(false);
  const [openDepartureWarning, setOpenDepartureWarning] = useState(false);

  const currentAttendee = getCurrentAttendee(entities);

  const fieldsId = parseFieldsByInternalId(currentAttendee.fields, attendeeTypeCustomFieldsRaw);
  const arrivalAirportTransferId = fieldsId[INTERNAL_IDS.needArrivalAirportTransfer];
  const departureAirportTransferId = fieldsId[INTERNAL_IDS.needDepartureAirportTransfer];
  const hotelCheckInId = fieldsId[INTERNAL_IDS.checkIn];
  const hotelCheckOutId = fieldsId[INTERNAL_IDS.checkOut];
  const hotelNameId = fieldsId[INTERNAL_IDS.hotelName];
  const dietaryRequirementId = fieldsId[INTERNAL_IDS.dietaryRequirements];
  const sundayDinnerId = fieldsId[INTERNAL_IDS.sundayDinner];
  const arrivalDateId = fieldsId[INTERNAL_IDS.arrivalDate];
  const departureDateId = fieldsId[INTERNAL_IDS.departureDate];
  const arrivalTimeId = fieldsId[INTERNAL_IDS.arrivalTime];
  const arrivalFromId = fieldsId[INTERNAL_IDS.arrivalFrom];
  const arrivalToId = fieldsId[INTERNAL_IDS.arrivalTo];
  const departureTimeId = fieldsId[INTERNAL_IDS.departureTime];
  const departureToId = fieldsId[INTERNAL_IDS.departureTo];
  const departureFromId = fieldsId[INTERNAL_IDS.departureFrom];
  const emergencyPhoneId = fieldsId[INTERNAL_IDS.emergencyContactPhone];
  const needHelpPhoneId = fieldsId[INTERNAL_IDS.needHelpPhone];
  const arrivalCommentsId = fieldsId[INTERNAL_IDS.arrivalComments];
  const departureCommentsId = fieldsId[INTERNAL_IDS.departureComments];

  const injectedLabelsFields = {
    cantArrivalTransfer: {
      id: 'cantArrivalTransfer',
      order: attendeeTypeCustomFieldsRaw[arrivalAirportTransferId]?.order + 0.1,
      name: cantArrivalTransferFieldName,
      inputType: INPUT_TYPES.LABEL,
      attendeeType: { id: undefined },
      display: false,
      secondaryColor: true,
    },
    cantDepartureTransfer: {
      id: 'cantDepartureTransfer',
      order: attendeeTypeCustomFieldsRaw[departureAirportTransferId]?.order + 0.1,
      name: cantDepartureTransferFieldName,
      inputType: INPUT_TYPES.LABEL,
      attendeeType: { id: undefined },
      display: false,
      secondaryColor: true,
    },
    specifyYourSpecialDiet: {
      id: 'specifyYourSpecialDiet',
      order: attendeeTypeCustomFieldsRaw[dietaryRequirementId]?.order + 0.1,
      name: specifyYourSpecialDietName,
      inputType: INPUT_TYPES.LABEL,
      attendeeType: { id: undefined },
      display: true,
      secondaryColor: true,
    },
    selectYourActivity: {
      id: 'selectYourActivity',
      order: attendeeTypeCustomFieldsRaw[sundayDinnerId]?.order + 0.1,
      name: 'selectYourActivity',
      jsxContent: selectYourActivityName,
      inputType: INPUT_TYPES.LABEL,
      attendeeType: { id: undefined },
      display: false,
      secondaryColor: true,
    },
    checkinCheckoutPreFilled: {
      id: 'checkinCheckoutPreFilled',
      order: attendeeTypeCustomFieldsRaw[hotelNameId]?.order - 0.1,
      name: checkinCheckoutPreFilledName,
      inputType: INPUT_TYPES.LABEL,
      attendeeType: { id: undefined },
      display: false,
      secondaryColor: true,
    },
    disabledModificationsArrival: {
      id: 'disabledModificationsArrival',
      order: attendeeTypeCustomFieldsRaw[arrivalDateId]?.order - 0.1,
      name: disabledModificationsArrivalName,
      inputType: INPUT_TYPES.LABEL,
      attendeeType: { id: undefined },
      display: false,
      secondaryColor: true,
    },
    disabledModificationsAgenda: {
      id: 'disabledModificationsAgenda',
      order: attendeeTypeCustomFieldsRaw[sundayDinnerId]?.order - 0.1,
      name: disabledModificationsAgendaName,
      inputType: INPUT_TYPES.LABEL,
      attendeeType: { id: undefined },
      display: false,
      secondaryColor: true,
    },
  };

  const attendeeTypeCustomFields = useMemo(() => {
    const newObj = { ...attendeeTypeCustomFieldsRaw };

    newObj.cantArrivalTransfer = injectedLabelsFields.cantArrivalTransfer;
    newObj.cantArrivalTransfer.attendeeType.id = currentAttendee.attendeeType.id;
    newObj.cantDepartureTransfer = injectedLabelsFields.cantDepartureTransfer;
    newObj.cantDepartureTransfer.attendeeType.id = currentAttendee.attendeeType.id;
    newObj.specifyYourSpecialDiet = injectedLabelsFields.specifyYourSpecialDiet;
    newObj.specifyYourSpecialDiet.attendeeType.id = currentAttendee.attendeeType.id;
    newObj.selectYourActivity = injectedLabelsFields.selectYourActivity;
    newObj.selectYourActivity.attendeeType.id = currentAttendee.attendeeType.id;
    newObj.checkinCheckoutPreFilled = injectedLabelsFields.checkinCheckoutPreFilled;
    newObj.checkinCheckoutPreFilled.attendeeType.id = currentAttendee.attendeeType.id;
    newObj.disabledModificationsArrival = injectedLabelsFields.disabledModificationsArrival;
    newObj.disabledModificationsArrival.attendeeType.id = currentAttendee.attendeeType.id;
    newObj.disabledModificationsAgenda = injectedLabelsFields.disabledModificationsAgenda;
    newObj.disabledModificationsAgenda.attendeeType.id = currentAttendee.attendeeType.id;
    // newObj.downloadVisaInvitationButton = {
    //   id: 'downloadVisaInvitationButton',
    //   order: 13.1,
    //   name: 'downloadVisaInvitationButton',
    //   inputType: INPUT_TYPES.DOWNLOAD_BUTTON,
    //   attendeeType: {
    //     id: undefined,
    //   },
    //   display: true,
    // };
    return newObj;
  }, [attendeeTypeCustomFieldsRaw]);

  const customFields = parseCustomFields(currentAttendee.fields, attendeeTypeCustomFields);
  const {
    firstName,
    lastName,
    email,
    birthdate,
    alternativeEmail,
    company,
    jobTitle,
    cityId,
    headshot,
    telephone,
  } = customFields;
  // const { attendanceMode } = attendeeTypes[currentAttendee.attendeeType.id];
  const formValues = watchFormValues();

  const phone = formValues['attendee[telephone]'] || telephone;
  const locationInfo = formValues['attendee[city_id]'] || cityId;
  const [selectedHeadshot, setSelectedHeadshot] = useState([]);

  // const showLeadsOptions = moduleEnabledForCurrentAttendeeType(entities, 'AttendeeLeads');
  const filename = useMemo(() => headshot?.filename, [headshot]);

  useEffect(() => {
    setSelectedHeadshot([]);
  }, [filename]);

  useEffect(() => {
    customErrors.forEach(({ name, type, message }) => setError(name, { type, message }));
  }, [customErrors]);

  useEffect(() => {
    registerInput({ name: 'attendee[telephone]' }, { required: true });
    registerInput({ name: 'attendee[city_id]' });
    registerInput({ name: 'attendee[headshot]' });
    registerInput({ name: 'attendee[birthdate]' });
    if (emergencyPhoneId) registerInput({ name: `attendee[customFields]._${emergencyPhoneId}` });
    if (needHelpPhoneId) registerInput({ name: `attendee[customFields]._${needHelpPhoneId}` });
  }, [registerInput, emergencyPhoneId, needHelpPhoneId]);

  const attendeeFields = useMemo(() => {
    const result = Object.keys(currentAttendee.fields);
    result.push(...Object.keys(injectedLabelsFields));
    // result.push('downloadVisaInvitationButton');
    return result;
  }, [currentAttendee.fields]);

  const defaultFieldsProps = useMemo(() => {
    if (!attendeeFields) return {};
    const names = {};
    attendeeFields.forEach((id) => {
      const { name, alias, display } = attendeeTypeCustomFields[id];
      names[name] = {
        name: alias || (name === 'city_id' ? '' : t(`forms.${camelize(name)}`)),
        display,
      };
    });
    return names;
  }, [attendeeFields]);

  const modalClose = () => {
    setOpenEditPhoto(false);
    setSelectedHeadshot([]);
    if (!headshot) setFormValue('attendee[headshot]', []);
  };

  const airportIsValid = airportValidations(formValues, fieldsId);
  const frontErrors = frontPreValidations(formValues, fieldsId);
  const disabled = submitDisabled || !!Object.values(frontErrors).length;

  const headshotField = getCustomFieldValue(formValues, null, 'headshot');
  const hotelCheckInField = getCustomFieldValue(formValues, hotelCheckInId);
  const hotelCheckOutField = getCustomFieldValue(formValues, hotelCheckOutId);
  const arrivalTransferField = getCustomFieldValue(formValues, arrivalAirportTransferId);
  const departureTransferField = getCustomFieldValue(formValues, departureAirportTransferId);
  const dietaryRequirementField = getCustomFieldValue(formValues, dietaryRequirementId);
  const arrivalDateField = getCustomFieldValue(formValues, arrivalDateId);
  const departureDateField = getCustomFieldValue(formValues, departureDateId);
  const accompanyingGuestField = getCustomFieldValue(formValues, fieldsId[1951]);
  const accompanyingGuestJoiningField = getCustomFieldValue(formValues, fieldsId[1955]);
  const accompanyingGuestSameRoomField = getCustomFieldValue(formValues, fieldsId[1952]);
  const guestEmailId = fieldsId[19551];
  const showGuestEmailMessage = (
    accompanyingGuestJoiningField
    && accompanyingGuestJoiningField !== 'No'
  );
  const arrivalTimeField = getCustomFieldValue(formValues, arrivalTimeId);
  const arrivalFromField = getCustomFieldValue(formValues, arrivalFromId);
  const arrivalToField = getCustomFieldValue(formValues, arrivalToId);
  const arrivalCommentsField = getCustomFieldValue(formValues, arrivalCommentsId);
  const departureTimeField = getCustomFieldValue(formValues, departureTimeId);
  const departureToField = getCustomFieldValue(formValues, departureToId);
  const departureFromField = getCustomFieldValue(formValues, departureFromId);
  const departureCommentsField = getCustomFieldValue(formValues, departureCommentsId);
  // const departurePickupField = getCustomFieldValue(formValues, fieldsId[111]);
  const arrivalFlightField = getCustomFieldValue(
    formValues,
    fieldsId[INTERNAL_IDS.arrivalFlightNumber]
  );
  const departureFlightField = getCustomFieldValue(
    formValues,
    fieldsId[INTERNAL_IDS.departureFlightNumber]
  );
  const emergencyPhoneField = getCustomFieldValue(formValues, emergencyPhoneId);
  const needHelpPhoneField = getCustomFieldValue(formValues, needHelpPhoneId);

  const [hasArrivalInfo, setHasArrivalInfo] = useState(!!arrivalFlightField);
  const [hasDepartureInfo, setHasDepartureInfo] = useState(!!departureFlightField);
  const autoFilledFieldEmpty = {
    [INTERNAL_IDS.arrivalTime]: !hasArrivalInfo && !arrivalTimeField,
    [INTERNAL_IDS.arrivalFrom]: !hasArrivalInfo && !arrivalFromField,
    [INTERNAL_IDS.arrivalTo]: !hasArrivalInfo && !arrivalToField,
    [INTERNAL_IDS.arrivalComments]: !hasArrivalInfo && !arrivalCommentsField,
    [INTERNAL_IDS.departureTime]: !hasDepartureInfo && !departureTimeField,
    [INTERNAL_IDS.departureTo]: !hasDepartureInfo && !departureToField,
    [INTERNAL_IDS.departureFrom]: !hasDepartureInfo && !departureFromField,
    [INTERNAL_IDS.departureComments]: !hasDepartureInfo && !departureCommentsField,
    // [INTERNAL_IDS.departurePickUpTime]: !hasDepartureInfo && !departurePickupField,
  };

  const EVENT_START = baseMoment('2026-01-01'); // tempoteray change
  const EVENT_END = baseMoment('2026-06-20'); // tempoteray change

  const isCheckInOutsideEvent = useMemo(() => !baseMoment(hotelCheckInField).isBetween(EVENT_START, EVENT_END, 'day', '[]'), [hotelCheckInField]);
  const isCheckOutOutsideEvent = useMemo(() => !baseMoment(hotelCheckOutField).isBetween(EVENT_START, EVENT_END, 'day', '[]'), [hotelCheckOutField]);

  const hotelCheckInDiffersArrivalDate = !baseMoment(hotelCheckInField).isSame(arrivalDateField, 'day');
  const hotelCheckOutDiffersDepartureDate = !baseMoment(hotelCheckOutField).isSame(departureDateField, 'day');

  useEffect(() => {
    if (!dietaryRequirementField && dietaryRequirementId) setFormValue(
      `attendee[customFields]._${dietaryRequirementId}`,
      'No'
    );
  }, [setFormValue, dietaryRequirementId, dietaryRequirementField]);

  useEffect(() => {
    if (!arrivalTransferField && arrivalAirportTransferId) setFormValue(
      `attendee[customFields]._${arrivalAirportTransferId}`,
      'YES'
    );
  }, [setFormValue, arrivalAirportTransferId, arrivalTransferField]);

  useEffect(() => {
    if (!departureTransferField && departureAirportTransferId) setFormValue(
      `attendee[customFields]._${departureAirportTransferId}`,
      'YES'
    );
  }, [setFormValue, departureAirportTransferId, departureTransferField]);

  useEffect(() => {
    if (hotelCheckInDiffersArrivalDate && arrivalAirportTransferId) setFormValue(
      `attendee[customFields]._${arrivalAirportTransferId}`,
      'NO'
    );
  }, [setFormValue, hotelCheckInDiffersArrivalDate, arrivalAirportTransferId]);

  useEffect(() => {
    if (hotelCheckOutDiffersDepartureDate && departureAirportTransferId) setFormValue(
      `attendee[customFields]._${departureAirportTransferId}`,
      'NO'
    );
  }, [setFormValue, hotelCheckOutDiffersDepartureDate, departureAirportTransferId]);

  useEffect(() => {
    if (isCheckInOutsideEvent && arrivalAirportTransferId) setFormValue(`attendee[customFields]._${arrivalAirportTransferId}`, 'NO');
  }, [isCheckInOutsideEvent, arrivalAirportTransferId, setFormValue]);

  useEffect(() => {
    if (isCheckOutOutsideEvent && departureAirportTransferId) setFormValue(`attendee[customFields]._${departureAirportTransferId}`, 'NO');
  }, [isCheckOutOutsideEvent, departureAirportTransferId, setFormValue]);

  useEffect(() => {
    if (hotelCheckInDiffersArrivalDate
      && (hotelCheckInField !== undefined
        && arrivalDateField !== undefined)) setOpenArrivalWarning(true);
  }, [
    hotelCheckInDiffersArrivalDate,
    hotelCheckInField,
    arrivalDateField,
  ]);

  useEffect(() => {
    if (hotelCheckOutDiffersDepartureDate
      && (hotelCheckOutField !== undefined
        && departureDateField !== undefined)) setOpenDepartureWarning(true);
  }, [
    hotelCheckOutDiffersDepartureDate,
    hotelCheckOutField,
    departureDateField,
  ]);

  const visaFields = {
    firstName: formValues['attendee[first_name]'],
    lastName: formValues['attendee[last_name]'],
    birthdate: formValues['attendee[birthdate]'],
    jobTitle: formValues['attendee[job_title]'],
    passportNumber: formValues[
      `attendee[customFields]._${fieldsId[INTERNAL_IDS.passportNumber]}`
    ],
    passportExpiryDate: formValues[
      `attendee[customFields]._${fieldsId[INTERNAL_IDS.passportExpiryDate]}`
    ],
    checkinDate: formValues[
      `attendee[customFields]._${fieldsId[INTERNAL_IDS.checkIn]}`
    ],
    checkoutDate: formValues[
      `attendee[customFields]._${fieldsId[INTERNAL_IDS.checkOut]}`
    ],
    hotel: formValues[
      `attendee[customFields]._${fieldsId[INTERNAL_IDS.hotelName]}`
    ],
    zoneDetails: currentAttendee.fields[
      fieldsId[INTERNAL_IDS.zonesDetails]
    ],
  };
  const visaButtonEnabled = visaInvitationLinkEnabled(visaFields);
  const downloadVisaInvitationButton = (
    <a
      href={
        visaButtonEnabled ? downloadVisaInvitationLink(visaFields) : undefined
      }
      download
      className={clsx(
        classes.downloadVisaInvitationButton,
        !visaButtonEnabled && classes.downloadVisaInvitationButtonDisabled
      )}
    >
      <DownloadIcon />
      Download your invitation letter for your visa
    </a>
  );

  const arrivalRelatedFields = {
    [INTERNAL_IDS.arrivalFlightNumber]: true,
    [INTERNAL_IDS.arrivalTime]: true,
    [INTERNAL_IDS.arrivalFrom]: true,
    [INTERNAL_IDS.arrivalTo]: true,
    [INTERNAL_IDS.arrivalComments]: true,
  };
  const departureRelatedFields = {
    [INTERNAL_IDS.departureFlightNumber]: true,
    [INTERNAL_IDS.departureTime]: true,
    [INTERNAL_IDS.departureTo]: true,
    [INTERNAL_IDS.departureFrom]: true,
    [INTERNAL_IDS.departureComments]: true,
    // [INTERNAL_IDS.111]: true, pickup time
  };

  const accompanyingGuestRelatedFields = {
    19111: true,
    195112: true,
    // 195113: true => relationshio whit this guest
    1953: true,
    1952: true,
    19521: true,
    1954: true,
    1955: true,
    19551: true,
  };

  const guestJoiningCWIRelatedFields = {
    19551: true,
  };

  const guestSameRoomCWIRelatedFields = {
    19521: true,
  };

  const hiddenFields = useMemo(() => {
    let result = {
      [cantArrivalTransferFieldName]: true,
      [cantDepartureTransferFieldName]: true,
      [specifyYourSpecialDietName]: true,
      [INTERNAL_IDS.seatingArea]: true,
      [INTERNAL_IDS.seatNumber]: true,
      // 19551: true,
    };

    if (accompanyingGuestField === 'No') result = { ...result, ...accompanyingGuestRelatedFields };
    if (accompanyingGuestJoiningField === 'No') result = { ...result, ...guestJoiningCWIRelatedFields };
    if (accompanyingGuestSameRoomField === 'No') result = { ...result, ...guestSameRoomCWIRelatedFields };

    // Esos if below no sirven => la comparacion debe ser con "No" y no con "NO"
    if (arrivalTransferField === 'NO') result = { ...result, ...arrivalRelatedFields };
    if (departureTransferField === 'NO') result = { ...result, ...departureRelatedFields };

    if (dietaryRequirementField === 'No') result = {
      ...result,
      [INTERNAL_IDS.specifyYourSpecialDiet]: true,
      [INTERNAL_IDS.medicalFoodAllergies]: true,
      [specifyYourSpecialDietName]: true,
    };
    else if (dietaryRequirementField === 'Yes') result = {
      ...result,
      [specifyYourSpecialDietName]: false,
    };

    if (hotelCheckInDiffersArrivalDate || isCheckInOutsideEvent) result = {
      ...result,
      [INTERNAL_IDS.needArrivalAirportTransfer]: false, // temporary true to force enable flight api
      [cantArrivalTransferFieldName]: false,
    };
    if (hotelCheckOutDiffersDepartureDate || isCheckOutOutsideEvent) result = {
      ...result,
      [INTERNAL_IDS.needDepartureAirportTransfer]: false,
      [cantDepartureTransferFieldName]: false,
    };
    return result;
  }, [
    arrivalTransferField, departureTransferField, hotelCheckInDiffersArrivalDate,
    hotelCheckOutDiffersDepartureDate, dietaryRequirementField, arrivalRelatedFields,
    departureRelatedFields, isCheckInOutsideEvent, isCheckOutOutsideEvent,
    accompanyingGuestSameRoomField, guestSameRoomCWIRelatedFields,
    accompanyingGuestField, accompanyingGuestRelatedFields,
    // accompanyingGuestJoiningField,
  ]);
  const shouldForceDisable = useMemo(() => {
    const result = {};

    if (hotelCheckInDiffersArrivalDate || isCheckInOutsideEvent) result[
      INTERNAL_IDS.needArrivalAirportTransfer] = true;
    if (hotelCheckOutDiffersDepartureDate || isCheckOutOutsideEvent) result[
      INTERNAL_IDS.needDepartureAirportTransfer] = true;

    return result;
  }, [
    hotelCheckInDiffersArrivalDate,
    hotelCheckOutDiffersDepartureDate,
    isCheckInOutsideEvent,
    isCheckOutOutsideEvent,
  ]);

  // const progress = getProgress(formValues, currentAttendee, attendeeTypeCustomFields);
  const [progress, setProgress] = useState(
    getProgress(formValues, currentAttendee, attendeeTypeCustomFields)
  );
  useEffect(() => {
    setProgress(
      getProgress(formValues, currentAttendee, attendeeTypeCustomFields)
    );
  }, [formValues, currentAttendee, attendeeTypeCustomFields]);

  const hasHeadshotChanged = Array.isArray(headshotField) && headshotField[0] instanceof File;
  const headshotPreviewSrc = hasHeadshotChanged ? URL.createObjectURL(headshotField[0]) : undefined;

  const extraProps = {
    // checkinDate
    [INTERNAL_IDS.checkIn]: {
      defaultCalendarMonth: '2026-06-01',
    },
    // checkoutDate
    [INTERNAL_IDS.checkOut]: {
      defaultCalendarMonth: '2026-06-01',
    },
    [INTERNAL_IDS.arrivalDate]: {
      defaultCalendarMonth: '2026-06-01',
    },
    [INTERNAL_IDS.departureDate]: {
      defaultCalendarMonth: '2026-06-01',
    },
    // [INTERNAL_IDS.myHeight]: {
    //   helperText: 'If you choose the Cycling Tour, please specify your Height.',
    // },
    // role TODO
    // 14: {
    //   forceRequired: true,
    // },
  };

  const sortedFields = Object.values(attendeeTypeCustomFields)
    .filter(({ id }) => attendeeFields.includes(id))
    .sort((a, b) => {
      const orderA = typeof a.order === 'number' && !Number.isNaN(a.order) ? a.order : 999;
      const orderB = typeof b.order === 'number' && !Number.isNaN(b.order) ? b.order : 999;
      return orderA - orderB;
    });

  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  return (
    <>
      <FileModal
        title={t('actions.editPhoto')}
        open={openEditPhoto}
        handleClose={modalClose}
        action={{
          name: t('actions.accept'),
          onClick: () => setOpenEditPhoto(false),
          disabled: !selectedHeadshot.length,
        }}
        fileInputProps={{
          id: 'attendee[headshot]',
          name: 'attendee[headshot]',
          label: errors?.attendee?.['headshot']?.message || '',
          type: 'image',
          accept: 'image/*',
          error: errors?.attendee?.['headshot']?.message,
          value: selectedHeadshot,
          handleChange: (val) => {
            setSelectedHeadshot(val);
            setFormValue('attendee[headshot]', val);
          },
        }}
      />
      <Dialog
        open={openArrivalWarning}
        onClose={() => setOpenArrivalWarning(false)}
        maxWidth="sm"
        fullWidth
      >

        <DialogContent>
          {hotelCheckInDiffersArrivalDate && (
            <Typography>
              You cannot request a transfer because your arrival date is different
              from your hotel check-in date.
              We only organize transfers from the airport to the hotel.
              Thank you for your understanding.
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenArrivalWarning(false)}
          >
            I Understand
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDepartureWarning}
        onClose={() => setOpenDepartureWarning(false)}
        maxWidth="sm"
        fullWidth
      >

        <DialogContent>
          {hotelCheckOutDiffersDepartureDate && (
            <Typography>
              You cannot request a transfer because your departure date is different
              from your hotel check-out date.
              We only organize transfers from the hotel to the airport.
              Thank you for your understanding.
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenDepartureWarning(false)}
          >
            I Understand
          </Button>
        </DialogActions>
      </Dialog>

      {/* <div className={clsx(classes.profileHeaderHybrid,
        mobile && classes.profileHeaderHybridMobile)}
      >
        <div className={classes.profileHeader}>
          {(attendanceMode !== VIRTUAL && showLeadsOptions) && (
            <MyQrButton
              attendeeInfo={{ ...customFields, uuid: currentAttendee.uuid }}
            />
          )}
        </div>
      </div> */}
      <Grid container spacing={1} className={classes.mainInfoWrapper}>
        <Grid item container spacing={2} xs={12} md={8}>
          {sortedFields.map((field) => {
            if (field && field.display) if (field.default) {
              const { name } = field;
              switch (name) {
                case 'first_name':
                  return defaultFieldsProps.first_name.display ? (
                    <Grid item xs={12} key={field.id}>
                      <InputBase
                        className={classes.simpleInput}
                        id="attendee[first_name]"
                        name="attendee[first_name]"
                        label={`${defaultFieldsProps.first_name.name} *`}
                        placeholder={defaultFieldsProps.first_name.name}
                        defaultValue={firstName}
                        inputRef={registerInput({
                          required: { value: true, message: t('formError.requiredField') },
                        })}
                        error={errors?.attendee?.['first_name']?.message}
                      />
                    </Grid>
                  ) : null;
                case 'last_name':
                  return defaultFieldsProps.last_name.display ? (
                    <Grid item xs={12} key={field.id}>
                      <InputBase
                        className={classes.simpleInput}
                        id="attendee[last_name]"
                        name="attendee[last_name]"
                        label={`${defaultFieldsProps.last_name.name} *`}
                        placeholder={defaultFieldsProps.last_name.name}
                        defaultValue={lastName}
                        inputRef={registerInput({
                          required: { value: true, message: t('formError.requiredField') },
                        })}
                        error={errors?.attendee?.['last_name']?.message}
                      />
                    </Grid>
                  ) : null;
                case 'email':
                  return defaultFieldsProps.email.display ? (
                    <Grid item xs={12} key={field.id}>
                      <InputBase
                        className={classes.simpleInput}
                        id="attendee[email]"
                        name="attendee[email]"
                        label={`${defaultFieldsProps.email.name}`}
                        placeholder={defaultFieldsProps.email.name}
                        defaultValue={email}
                        inputRef={registerInput({
                          required: { value: true, message: t('formError.requiredField') },
                          pattern: { value: emailRegexp, message: t('formError.enterValidEmail') },
                        })}
                        error={errors?.attendee?.['email']?.message}
                      />
                    </Grid>
                  ) : null;
                case 'telephone':
                  return defaultFieldsProps.telephone.display ? (
                    <Grid item xs={12} key={field.id}>
                      <PhoneInput
                        className={classes.simpleInput}
                        id="attendee[telephone]"
                        name="attendee[telephone]"
                        label={defaultFieldsProps.telephone.name}
                        value={phone || ''}
                        handleChange={(val) => setFormValue('attendee[telephone]', val || '')}
                        error={errors?.attendee?.['telephone']?.message}
                      />
                    </Grid>
                  ) : null;
                default:
                  return null;
              }
            }
            return null;
          })}
        </Grid>
        <Grid
          item
          container
          spacing={1}
          xs={12}
          md={4}
          className={classes.avatarGrid}
        >
          <div className={classes.avatarWrapper}>
            <div className={classes.profilePhotoTitle}>
              <Typography
                className={classes.labelText}
              >
                Profile Photo *
              </Typography>
            </div>
            <IconButton
              className={classes.editPhotoButton}
              aria-label="edit-photo"
              onClick={() => setOpenEditPhoto(true)}
              edge="end"
              color="primary"
              size="small"
            >
              <CreateIcon />
            </IconButton>
            <div className={classes.progressWrapper}>
              <CircularProgress
                variant="determinate"
                className={classes.progressBakcground}
                size={83}
                thickness={1}
                value={100}
              />
              <CircularProgress
                variant="static"
                className={classes.progress}
                size={83}
                thickness={1}
                value={progress}
                style={{ transform: 'rotate(60deg)' }}
              />
              <Typography className={classes.progressValue}>
                {progress}%
              </Typography>
            </div>
            <Typography className={classes.progressComplete} variant="body1">
              {progress === 100 ? 'PROFILE COMPLETED' : 'COMPLETE YOUR PROFILE'}
            </Typography>
            {hasHeadshotChanged && (
              <Typography className={classes.headshotReminder} variant="body1">
                Please save your profile below to update your photo
              </Typography>
            )}
            <Avatar
              src={headshotPreviewSrc || (headshot?.filename && headshot.medium)}
              className={classes.avatar}
            />
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={2} className={classes.customFieldsWrapper}>
        {sortedFields.map((field) => {
          // eslint-disable-next-line curly
          if (field && field.display
            && !validateField(hiddenFields, field.internalId, field.name)
          ) {
            if (field.default) {
              const { name } = field;
              switch (name) {
                case 'birthdate':
                  return defaultFieldsProps.birthdate.display ? (
                    <Grid
                      item
                      xs={12}
                      md={validateField(fieldSizes, field.internalId, field.name) || 12}
                      key={field.id}
                    >
                      <DateInput
                        className={classes.simpleInput}
                        id="attendee[birthdate]"
                        name="attendee[birthdate]"
                        format="DD/MM/YYYY"
                        label={defaultFieldsProps.birthdate.name}
                        value={birthdate || ''}
                        handleChange={(val) => setFormValue('attendee[birthdate]', val)}
                        error={errors?.attendee?.['birthdate']?.message}
                      />
                    </Grid>
                  ) : null;
                case 'company':
                  return defaultFieldsProps.company.display ? (
                    <Grid
                      item
                      xs={12}
                      md={validateField(fieldSizes, field.internalId, field.name) || 12}
                      key={field.id}
                    >
                      <InputBase
                        className={classes.simpleInput}
                        id="attendee[company]"
                        name="attendee[company]"
                        label={defaultFieldsProps.company.name}
                        placeholder={defaultFieldsProps.company.name}
                        defaultValue={company}
                        inputRef={registerInput()}
                        error={errors?.attendee?.['company']?.message}
                        required
                      />
                    </Grid>
                  ) : null;
                case 'job_title':
                  return defaultFieldsProps.job_title.display ? (
                    <Grid
                      item
                      xs={12}
                      md={validateField(fieldSizes, field.internalId, field.name) || 12}
                      key={field.id}
                    >
                      <InputBase
                        className={classes.simpleInput}
                        id="attendee[job_title]"
                        name="attendee[job_title]"
                        label={defaultFieldsProps.job_title.name}
                        placeholder={defaultFieldsProps.job_title.name}
                        defaultValue={jobTitle}
                        inputRef={registerInput()}
                        error={errors?.attendee?.['job_title']?.message}
                        required
                      />
                    </Grid>
                  ) : null;
                case 'city_id':
                  return defaultFieldsProps.city_id.display ? (
                    <CountryField
                      handleChange={(val) => setFormValue('attendee[city_id]', val)}
                      identifiers={{
                        city: 'attendee[city_id]',
                        region: 'attendee[region_id]',
                        country: 'attendee[country_id]',
                      }}
                      error={errors?.attendee?.['city_id']?.message}
                      value={locationInfo}
                      key={field.id}
                    />
                  ) : null;
                case 'alternative_email':
                  return defaultFieldsProps.alternative_email.display ? (
                    <Grid
                      item
                      xs={12}
                      md={validateField(fieldSizes, field.internalId, field.name) || 12}
                      key={field.id}
                    >
                      <InputBase
                        className={classes.simpleInput}
                        id="attendee[alternative_email]"
                        name="attendee[alternative_email]"
                        label={`${defaultFieldsProps.alternative_email.name}`}
                        helperText={(
                          <>
                            This person will be in copy of all the emails.
                            <br />
                            They will be able to connect to your profile and modify it.
                          </>
                        )}
                        placeholder={defaultFieldsProps.alternative_email.name}
                        defaultValue={alternativeEmail}
                        inputRef={registerInput({
                          pattern: { value: emailRegexp, message: t('formError.enterValidEmail') },
                        })}
                        error={errors?.attendee?.['alternative_email']?.message}
                      />
                    </Grid>
                  ) : null;
                default:
                  return null;
              }
            } else {
              if (field.internalId === INTERNAL_IDS.downloadInvitationLetter) return (
                <Grid
                  item
                  xs={12}
                  md={validateField(fieldSizes, field.internalId, field.name) || 12}
                  key={field.id}
                >
                  <CustomField
                    getIdentifier={(id) => `attendee[customFields]._${id}`}
                    field={{
                      ...field,
                      inputType: 500,
                      content: downloadVisaInvitationButton,
                    }}
                  />
                </Grid>
              );

              if (field.internalId === INTERNAL_IDS.emergencyContactPhone) {
                const id = `attendee[customFields]._${field.id}`;
                return (
                  <Grid
                    item
                    xs={12}
                    md={validateField(fieldSizes, field.internalId, field.name) || 12}
                    key={field.id}
                  >
                    <PhoneInput
                      className={classes.simpleInput}
                      id={id}
                      name={id}
                      label={field.name}
                      value={emergencyPhoneField || ''}
                      handleChange={(val) => setFormValue(id, val)}
                      error={errors?.attendee?.[`_${field.id}`]?.message}
                    />
                  </Grid>
                );
              }
              if (field.internalId === INTERNAL_IDS.needHelpPhone) {
                const id = `attendee[customFields]._${field.id}`;
                return (
                  <Grid
                    item
                    xs={12}
                    md={validateField(fieldSizes, field.internalId, field.name) || 12}
                    key={field.id}
                  >
                    <PhoneInput
                      className={classes.simpleInput}
                      id={id}
                      name={id}
                      label={field.name}
                      value={needHelpPhoneField || ''}
                      handleChange={(val) => setFormValue(id, val)}
                      error={errors?.attendee?.[`_${field.id}`]?.message}
                    />
                  </Grid>
                );
              }

              if ([
                INTERNAL_IDS.arrivalFlightNumber,
                INTERNAL_IDS.departureFlightNumber,
              ].includes(field.internalId)) {
                let helperText;
                if (field.internalId === INTERNAL_IDS.arrivalFlightNumber) helperText = 'If you cannot find your flight number, please share the details in the "Arrival Comment" field below.';
                if (field.internalId === INTERNAL_IDS.departureFlightNumber) helperText = 'If you cannot find your flight number, please share the details in the "Departure Comment" field below.';

                const id = `attendee[customFields]._${field.id}`;
                const flightValue = watchFormValues(id);

                let flightDate;
                let timeId;
                let fromPlaceId;
                let toPlaceId;
                let flightType;
                let setHasInfo;
                if (field.internalId === INTERNAL_IDS.arrivalFlightNumber) {
                  flightType = 'arrival';
                  flightDate = arrivalDateField;
                  timeId = `attendee[customFields]._${arrivalTimeId}`;
                  fromPlaceId = `attendee[customFields]._${arrivalFromId}`;
                  toPlaceId = `attendee[customFields]._${arrivalToId}`;
                  setHasInfo = setHasArrivalInfo;
                } else {
                  flightType = 'departure';
                  flightDate = departureDateField;
                  timeId = `attendee[customFields]._${departureTimeId}`;
                  fromPlaceId = `attendee[customFields]._${departureFromId}`;
                  toPlaceId = `attendee[customFields]._${departureToId}`;
                  setHasInfo = setHasDepartureInfo;
                }
                const onFlightSuccess = (timeValue, fromPlaceValue, toPlaceValue) => {
                  setFormValue(timeId, timeValue);
                  setFormValue(fromPlaceId, fromPlaceValue);
                  setFormValue(toPlaceId, toPlaceValue);
                  setHasInfo(true);
                };
                const setFlightError = (errorMessage) => {
                  setError(id, {
                    type: 'error',
                    message: errorMessage,
                  });
                  setHasInfo(!!errorMessage);
                };
                return (
                  <Grid
                    item
                    xs={12}
                    md={validateField(fieldSizes, field.internalId, field.name) || 12}
                    key={field.id}
                  >
                    <FlightInput
                      id={id}
                      label={field.name}
                      placeholder={field.name}
                      className={classes.simpleInput}
                      defaultValue={currentAttendee.fields[field.id]}
                      inputRef={registerInput}
                      error={errors?.attendee?.customFields?.[`_${field.id}`]?.types?.message}
                      disabled={field.editAdminOnly}
                      flightValue={flightValue}
                      flightDate={flightDate}
                      onFlightSuccess={onFlightSuccess}
                      setFlightError={setFlightError}
                      helperText={helperText}
                      flightType={flightType}
                    />
                  </Grid>
                );
              }

              return (
                <Grid
                  item
                  xs={12}
                  md={validateField(fieldSizes, field.internalId, field.name) || 12}
                  key={field.id}
                  className={clsx(
                    autoFilledFieldEmpty[field.internalId] && classes.hiddenField
                  )}
                >
                  <CustomField
                    getIdentifier={(id) => `attendee[customFields]._${id}`}
                    field={field}
                    value={currentAttendee.fields[field.id]}
                    inputRef={registerInput}
                    watchFormValues={watchFormValues}
                    setFormValue={setFormValue}
                    error={
                      frontErrors[field.id]
                      || airportIsValid[field.id]
                      || errors?.attendee?.customFields?.[`_${field.id}`]?.types?.message
                    }
                    disabled={field.editAdminOnly || shouldForceDisable[field.internalId]}
                    disabledButton={disabled}
                    clearError={clearError}
                    {...extraProps[field.internalId]}
                  />
                  {(field.id === guestEmailId && showGuestEmailMessage) && (
                    <Typography className={classes.guestEmailMessage} variant="caption">
                      Please provide your guest&apos;s email address, it must be different from yours.
                    </Typography>
                  )}
                </Grid>
              );
            }
          }
          return null;
        })}
        <Grid className={classes.buttonContainer} item xs={12}>
          <Button
            type="submit"
            disabled={disabled}
            onClick={() => clearError()}
            variant="primary"
          >
            {disabled ? t('status.saving') : t('actions.save')}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

MyProfileForm.propTypes = {
  disabled: PropTypes.bool,
  registerInput: PropTypes.func.isRequired,
  setFormValue: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  customErrors: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
    })
  ),
  watchFormValues: PropTypes.func.isRequired,
  errors: CustomPropTypes.formErrors.isRequired,
  entities: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
  attendeeTypeCustomFields: PropTypes.objectOf(
    CustomPropTypes.attendeeTypeCustomField
  ),
  // attendeeTypes: PropTypes.objectOf(
  //   CustomPropTypes.attendeeType
  // ).isRequired,
};

MyProfileForm.defaultProps = {
  disabled: false,
  customErrors: [],
  attendeeTypeCustomFields: {},
};

const mapStateToProps = ({
  entities,
  entities: {
    attendeeTypes,
    attendeeTypeCustomFields,
  },
}) => ({
  entities,
  attendeeTypes,
  attendeeTypeCustomFields,
});

export default compose(
  withForm({ required: false, autoComplete: 'off' }),
  connect(mapStateToProps)
)(MyProfileForm);
